import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import React, { useEffect, useRef, useState } from 'react';
import './contact.css';

function AppContact() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="contact"
      className="block contact-block"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(60px)',
        transition: 'opacity 0.7s ease, transform 0.7s ease',
        pointerEvents: visible ? 'auto' : 'none',
        padding: '60px 0',
        backgroundColor: '#f5f5f5'
      }}
    >
      <Container fluid="md">
       <div 
        className="title-holder-modern text-center py-5 px-3 px-md-4"
        style={{
          animation: visible ? 'slideInDown 0.9s ease' : 'none',
          opacity: visible ? 1 : 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          textAlign: 'left'
        }}
      >
        <h2
          className="section-title"
          style={{
            color: '#00761F',
            fontWeight: '700',
            fontSize: '2.4rem',
            textTransform: 'uppercase',
            marginBottom: '14px'
          }}
        >
          Contacto
        </h2>
        <div
          className="section-subtitle"
          style={{
            fontWeight: '500',
            color: '#444',
            fontSize: '1.25rem',
            letterSpacing: '0.5px',
            marginBottom: '10px'
          }}
        >
          Mantenha-se ligado
        </div>
        <div
          className="section-underline"
          style={{
            marginTop: '10px',
            width: '60px',
            height: '4px',
            backgroundColor: '#00761F',
            borderRadius: '2px'
          }}
        ></div>
      </div>
        <Form className="contact-form mb-5">
          <Row className="gy-4">
            <Col sm={12} md={4}>
              <Form.Control
                type="text"
                placeholder="Nome completo"
                required
                style={{ padding: '14px', borderRadius: '12px' }}
              />
            </Col>
            <Col sm={12} md={4}>
              <Form.Control
                type="email"
                placeholder="Endereço de email"
                required
                style={{ padding: '14px', borderRadius: '12px' }}
              />
            </Col>
            <Col sm={12} md={4}>
              <Form.Control
                type="tel"
                placeholder="Número de contato"
                required
                style={{ padding: '14px', borderRadius: '12px' }}
              />
            </Col>
            <Col sm={12}>
              <Form.Control
                as="textarea"
                rows={5}
                placeholder="Digite sua mensagem"
                required
                style={{ padding: '14px', borderRadius: '12px' }}
              />
            </Col>
            <Col sm={12} className="text-center">
              <Button
                type="submit"
                style={{
                  padding: '12px 28px',
                  backgroundColor: '#00761F',
                  border: 'none',
                  borderRadius: '30px',
                  fontWeight: 600
                }}
              >
                Enviar Mensagem
              </Button>
            </Col>
          </Row>
        </Form>

        <div className="google-map mb-5">
          <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7881.894291741407!2d13.167019400000004!3d-8.9770111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1spt-PT!2sao!4v1741772384409!5m2!1spt-PT!2sao"
            width="100%"
            height="450"
            style={{ border: '0', borderRadius: '12px' }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

<div className="contact-info text-center" style={{ padding: '10px' }}>
  <ul
    style={{
      listStyle: 'none',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}
  >
    <li
      style={{
        marginBottom: '12px',
        fontSize: '1rem',
        color: '#333',
        textAlign: 'center',
        wordWrap: 'break-word'
      }}
    >
      <i
        className="fas fa-envelope"
        style={{ color: '#00761F', marginBottom: '5px', display: 'block' }}
      ></i>
      secretariageral@ispatlantida.co.ao
    </li>
    <li
      style={{
        marginBottom: '12px',
        fontSize: '1rem',
        color: '#333',
        textAlign: 'center',
        wordWrap: 'break-word'
      }}
    >
      <i
        className="fas fa-phone"
        style={{ color: '#00761F', marginBottom: '5px', display: 'block' }}
      ></i>
      929 282 704
    </li>
    <li
      style={{
        fontSize: '1rem',
        color: '#333',
        textAlign: 'center',
        wordWrap: 'break-word'
      }}
    >
      <i
        className="fas fa-map-marker-alt"
        style={{ color: '#00761F', marginBottom: '5px', display: 'block' }}
      ></i>
      Benfica, Estrada Lar do Patriota, Junto a Rua 14, Luanda, Angola
    </li>
  </ul>
</div>

      </Container>

      <style>
        {`
          @keyframes slideInDown {
            0% {
              transform: translateY(-50px);
              opacity: 0;
            }
            100% {
              transform: translateY(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </section>
  );
}

export default AppContact;
